import { cn } from "@/lib/utils"
import Image from "next/image"
import logo from "./logo.svg"
import mobileLogo from "./mobile_logo.svg"
import { useIsMobile } from "@/hooks/use-is-mobile"

const Logo = (props) => {
  const { width, height, className } = props || {}

  const title = "Kingsyard"

  const { isMobile } = useIsMobile()

  return (
    <Image
      width={width}
      height={height}
      src={isMobile ? mobileLogo : logo}
      alt={title}
      title={title}
      className={className}
    />
  )
}

export default Logo
